(function (module) {
    "use strict";

    module.service('skipPeriodsService', ['synchronousEventsBus', '$q', function(this: $TSFixMe, synchronousEventsBus: $TSFixMe, $q: ng.IQService) {
        var service = this;

        service.registerEvents = function () {
            synchronousEventsBus.$on('dataAfterCorrectionChanged', function (e: $TSFixMe, args: $TSFixMe) {
                return service.skip(args.forecast, args.parameters, args.forecast.skippedStart, args.forecast.skippedEnd);
            });
        }

        service.skip = function (forecast: $TSFixMe, parameters: $TSFixMe, start: $TSFixMe, end: $TSFixMe) {


            if (angular.isUndefinedOrNull(forecast.dataAfterCorrection)) {
                return $q.when();
            }

            forecast.dataAfterSkipped = forecast.dataAfterCorrection.slice();
            for (var i = 0; i < forecast.dataAfterSkipped.length; ++i) {
                if (i < start || forecast.dataAfterSkipped.length - end <= i) {
                    forecast.dataAfterSkipped[i] = null;
                } else {
                    forecast.dataAfterSkipped[i] = forecast.dataAfterCorrection[i];
                }
            }
            return synchronousEventsBus.$broadcast('dataAfterSkippedChanged', { forecast: forecast, parameters: parameters });
        }
    }]);

    module.run(['skipPeriodsService', function (service: $TSFixMe) {
        service.registerEvents();
    }]);


})(angular.module('topline.services'));